import { montserrat } from '@/lib/font';
import styles from './PityHeader.module.scss';

function PityHeader({
  name,
}: {
  name: string;
}) {
  return (
    <>
      <div className={styles.headline}>
        <span className={`${montserrat.className} ${styles.title}`}>{name}</span>
        <span className={styles.small}>回特典</span>
      </div>
      <div className={styles.underline} />
    </>
  );
}

export default PityHeader;
